import { pick } from 'lodash';

const orderKeys = ['customer_name', 'system_status', 'order_number'];

export const transformOrders = (data) => {
  const args = {
    ...data,
    ...data?.attributes,
  };

  return pick(args, orderKeys);
};

const keys = [
  'is_new',
  'code',
  'created_at',
  'model_uuid',
  'order',
  'inventory',
  'rider',
  'type',
  'id',
];

export const transformGetNotification = (data) => {
  const { order } = data?.attributes || data || {};

  const args = {
    ...data,
    ...data?.attributes,
    order: transformOrders(order?.data),
  };

  return pick(args, keys);
};
